import { Component } from "react";

// Nexora (nexora-app) — filet de sécurité React (2026-08-28, retour utilisateur explicite :
// "j'obtiens ce fond blanc quand je me déconnecte de l'app"). Sans error boundary nulle
// part dans l'app, UNE seule exception non rattrapée pendant un rendu (ici probablement
// dans un composant encore monté au moment de la déconnexion, qui déréférence `user.xxx`
// sans garde le temps d'un rendu) démonte TOUT l'arbre React — l'utilisateur se retrouve
// sur une page blanche, sans message, sans indice. Ce composant capture ces exceptions,
// affiche un écran de secours explicite avec un bouton pour recharger, et journalise
// l'erreur réelle en console pour qu'un futur diagnostic n'ait plus à deviner dans le vide.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    console.error("[ErrorBoundary] Rendu React interrompu :", error, info?.componentStack);
    // Auto-guérison (2026-08-28) : un crash pendant le rendu empêche l'effet normal qui
    // nettoie nexora_user (voir App.jsx) de s'exécuter — l'objet corrompu/périmé reste en
    // cache et redéclenche le MÊME crash à chaque réouverture, y compris sur une icône
    // fraîchement réinstallée (constaté en conditions réelles : le stockage d'une icône déjà
    // installée sur iOS peut survivre à "Effacer les données de site" fait depuis Safari).
    // On efface ce cache dès la capture de l'erreur, jamais seulement au clic sur
    // "Recharger" — pour casser la boucle même si l'app est refermée sans y toucher.
    try { localStorage.removeItem("nexora_user"); } catch { /* best-effort */ }
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <div style={{
        minHeight: "100vh", display: "flex", flexDirection: "column", alignItems: "center",
        justifyContent: "center", padding: 32, fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', system-ui, sans-serif",
        textAlign: "center", background: "#fff", color: "#15181f",
      }}>
        <div style={{ fontSize: 40, marginBottom: 12 }}>⚠️</div>
        <strong style={{ fontSize: 18, marginBottom: 8 }}>Un problème est survenu</strong>
        <p style={{ fontSize: 14, color: "#7d8497", maxWidth: 320, margin: "0 0 22px" }}>
          L'application a rencontré une erreur inattendue. Recharge la page pour continuer.
        </p>
        {/* Détail technique affiché temporairement (chantier diagnostic 2026-08-28, "fond
            blanc à la déconnexion") — utile pour capturer/envoyer l'erreur exacte par
            capture d'écran ; à retirer une fois la cause réelle trouvée et corrigée. */}
        <p style={{ fontSize: 11, color: "#b0b4bf", maxWidth: 340, margin: "0 0 22px", fontFamily: "monospace", wordBreak: "break-word" }}>
          {String(this.state.error?.message || this.state.error)}
        </p>
        <button
          type="button"
          onClick={() => window.location.reload()}
          style={{
            padding: "13px 28px", borderRadius: 999, border: "none", fontWeight: 800,
            fontSize: 14, color: "#fff", background: "#364fe7", cursor: "pointer",
          }}
        >
          Recharger
        </button>
      </div>
    );
  }
}
